import { DialogContent, DialogTitle, Box, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  SaveButton,
  TextInput,
  SimpleForm,
  useDataProvider,
  useNotify,
  NumberInput,
  BooleanInput,
  ArrayInput,
  SimpleFormIterator,
  useTranslate,
} from 'react-admin';

export default function EditTask({
  id,
  resource,
  onClose,
}: {
  id: string;
  resource: any;
  onClose: () => void;
}) {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const translate = useTranslate();
  // const [record, setRecord] = useState<any>();
  const [saving, setSaving] = useState(false);

  // useEffect(() => {
  //   dataProvider.getOne('activity/adminGetAllTasks', { id }).then((res) => setRecord(res.data));
  // }, [dataProvider, id]);

  const onSubmit = async (values: any) => {
    setSaving(true);
    try {
      // 处理嵌套对象，确保数据格式正确
      const processedValues = {
        ...values,
        // 确保 isActive 是布尔值
        isActive: Boolean(values.isActive),
      };

      await dataProvider.update('activity-task-category', {
        id,
        data: processedValues,
        previousData: resource,
      });
      notify(translate('activity.categories.updatedSuccessfully'), { type: 'success' });
      onClose();
    } catch (error) {
      console.error('Update error:', error);
      notify(translate('activity.categories.failedToUpdate'), { type: 'error' });
    } finally {
      setSaving(false);
    }
  };

  // if (!record) {
  //   return (
  //     <>
  //       <DialogTitle>{translate('activity.common.editTask')}</DialogTitle>
  //       <DialogContent>
  //         <Typography>Loading...</Typography>
  //       </DialogContent>
  //     </>
  //   );
  // }

  return (
    <>
      <DialogTitle>{translate('activity.common.editTask')}</DialogTitle>
      <DialogContent>
        <SimpleForm
          defaultValues={resource}
          onSubmit={onSubmit}
          toolbar={<SaveButton alwaysEnable disabled={saving} />}
        >
          <Stack spacing={2} sx={{ mt: 2 }}>
            <Typography variant="h6">{translate('activity.common.basicInformation')}</Typography>
            <TextInput source="id" label={translate('activity.common.id')} fullWidth readOnly />
            <BooleanInput source="isActive" label={translate('activity.common.isActive')} />
            <TextInput source="name" label={translate('activity.common.name')} fullWidth required />
            <TextInput source="description" label={translate('activity.common.description')} fullWidth multiline rows={3} />
            <TextInput source="icon" label={translate('activity.common.icon')} fullWidth />
            <NumberInput source="sortOrder" label={translate('activity.common.sortOrder')} fullWidth  />
          </Stack>
        </SimpleForm>
      </DialogContent>
    </>
  );
}
